(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('top-collection-slider')) {
    customElements.define('top-collection-slider', class extends HTMLElement {
      connectedCallback() {
        this.syncVideos = this.syncVideos.bind(this);
        this.viewport = window.matchMedia('(min-width: 768px)');
        this.viewport.addEventListener('change', this.syncVideos);
        this.onVisibilityChange = () => this.syncVideos();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.slideObserver = new MutationObserver(this.syncVideos);
        this.slideObserver.observe(this, { subtree: true, attributes: true, attributeFilter: ['class'] });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.isVisible = entry.isIntersecting;
          this.syncVideos();
        });
        this.visibilityObserver.observe(this);
      }

      disconnectedCallback() {
        this.slideObserver.disconnect();
        this.visibilityObserver.disconnect();
        this.viewport.removeEventListener('change', this.syncVideos);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      syncVideos() {
        const slider = this.querySelector('slideshow-component');
        this.querySelectorAll('video').forEach((video) => {
          const slide = video.closest('.swiper-slide');
          const isActive = slider.dataset.enableSlider !== 'true' || slide.classList.contains('swiper-slide-active');
          const isDisplayed = video.closest('.top-collection-slider__media').getClientRects().length > 0;
          if (this.isVisible && !document.hidden && isActive && isDisplayed) {
            if (video.paused) video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.promotion-banner__copy-btn');
    if (!button) return;

    const icon = button.querySelector('.promotion-banner__copy-icon');
    if (!icon || icon.hidden) return;

    icon.classList.remove('is-copied');
    void icon.offsetWidth;
    icon.classList.add('is-copied');
  });

  if (!customElements.get('promotion-offer')) {
    class PromotionOffer extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.textEl = this.querySelector('[data-offer-text]');
        this.copyEl = this.querySelector('[data-offer-copy]');
        this.copyBtn = this.querySelector('[data-offer-copy-btn]');
        this.codeEl = this.querySelector('[data-offer-code]');
        this.iconEl = this.querySelector('[data-offer-icon]');
        this.codeWrap = this.querySelector('[data-offer-code-wrap]');
        this.toggleBtn = this.querySelector('[data-offer-toggle]');
        this.menu = this.querySelector('[data-offer-menu]');
        this.motionEl = this.closest('motion-element');
        this.stackEl = this.closest('.shopify-section') || this.closest('.section');

        if (!this.toggleBtn || !this.menu) return;

        this.toggleBtn.addEventListener('click', this.onToggle.bind(this), { signal });
        this.menu.addEventListener('mousedown', (event) => event.preventDefault(), { signal });
        this.menu.addEventListener('click', this.onMenuClick.bind(this), { signal });
        this.addEventListener('keydown', this.onKeydown.bind(this), { signal });
        this.addEventListener('focusout', this.onFocusOut.bind(this), { signal });
        document.addEventListener('click', this.onDocumentClick.bind(this), { signal });
        this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.setOpen(false);
      }

      get options() {
        return [...this.querySelectorAll('[data-offer-option]')];
      }

      onToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.menu.hidden) {
          this.open();
        } else {
          this.close();
        }
      }

      onDocumentClick(event) {
        if (!this.menu || this.menu.hidden) return;
        if (this.contains(event.target)) return;
        this.close();
      }

      onFocusOut(event) {
        if (!this.menu || this.menu.hidden) return;
        if (this.contains(event.relatedTarget)) return;
        this.close();
      }

      onMenuClick(event) {
        const option = event.target.closest('[data-offer-option]');
        if (!option) return;
        event.preventDefault();
        this.applyOffer(option);
        this.close();
        this.toggleBtn.focus();
      }

      onKeydown(event) {
        if (!this.menu) return;

        if (this.menu.hidden) {
          if (event.key === 'ArrowDown' && event.target === this.toggleBtn) {
            event.preventDefault();
            this.open();
          }
          return;
        }

        const options = this.options;
        if (!options.length) return;
        const current = options.indexOf(document.activeElement);

        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          this.toggleBtn.focus();
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          const nextIndex = current < 0 ? 0 : (current + 1) % options.length;
          options[nextIndex]?.focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          const previousIndex = current < 0 ? options.length - 1 : (current - 1 + options.length) % options.length;
          options[previousIndex]?.focus();
        }
      }

      onBlockSelect(event) {
        const option = event.target?.closest?.('[data-offer-option]');
        if (!option || !this.contains(option)) return;
        this.applyOffer(option);
        this.open();
      }

      open() {
        this.menu.hidden = false;
        this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.setOpen(true);
        const selected = this.menu.querySelector('[aria-selected="true"]') || this.options[0];
        selected?.focus();
      }

      close() {
        if (!this.menu || this.menu.hidden) {
          this.setOpen(false);
          return;
        }
        this.menu.hidden = true;
        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.setOpen(false);
      }

      setOpen(isOpen) {
        this.motionEl?.classList.toggle('is-open', isOpen);
        this.stackEl?.classList.toggle('promotion-banner-section--open', isOpen);
      }

      applyOffer(option) {
        const template = option.parentElement?.querySelector('template');
        if (this.textEl && template) {
          this.textEl.innerHTML = template.innerHTML;
          this.textEl.classList.remove('text-base-text', 'text-subtext');
          this.textEl.classList.add(`text-${option.dataset.textColor || 'base-text'}`);

          if (option.dataset.textSize) {
            this.textEl.classList.add('promotion-banner__text--custom-size');
            this.textEl.style.setProperty('--block-font-size', `${option.dataset.textSize}px`);
          } else {
            this.textEl.classList.remove('promotion-banner__text--custom-size');
            this.textEl.style.removeProperty('--block-font-size');
          }
        }

        const code = option.dataset.code || '';
        if (this.codeEl) this.codeEl.textContent = code;
        if (this.copyEl) {
          this.copyEl.dataset.copyValue = code;
          this.copyEl.hidden = code === '';
        }
        if (this.copyBtn) {
          const label = this.copyBtn.dataset.copyLabel || '';
          this.copyBtn.setAttribute('aria-label', `${label} ${code}`.trim());
        }
        if (this.iconEl) {
          this.iconEl.hidden = option.dataset.showIcon !== 'true';
          this.iconEl.classList.remove('is-copied');
        }
        if (this.codeWrap && option.dataset.codeSize) {
          this.codeWrap.style.setProperty('--block-font-size', `${option.dataset.codeSize}px`);
        }

        this.options.forEach((item) => {
          item.setAttribute('aria-selected', item === option ? 'true' : 'false');
        });
      }
    }

    customElements.define('promotion-offer', PromotionOffer);
  }

  if (!customElements.get('promotion-banner-dock')) {
    class PromotionBannerDock extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.handle = this.querySelector('[data-dock-handle]');
        this.content = this.querySelector('.promotion-banner__inner');
        this.storageKey = this.dataset.storageKey;
        this.mql = window.matchMedia('(max-width: 1023.98px)');
        if (!this.handle) return;

        let collapsed = false;
        try {
          collapsed = window.sessionStorage.getItem(this.storageKey) === 'collapsed';
        } catch (error) {}
        if (window.Shopify?.designMode) collapsed = false;
        this.setCollapsed(collapsed, false);

        this.handle.addEventListener('click', () => this.setCollapsed(!this.collapsed), { signal });
        this.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true, signal });
        this.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true, signal });
        this.mql.addEventListener('change', () => this.updateInert(), { signal });

        const section = this.closest('.shopify-section');
        section?.addEventListener('shopify:section:select', () => this.setCollapsed(false, false), { signal });
        section?.addEventListener('shopify:block:select', () => this.setCollapsed(false, false), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      setCollapsed(collapsed, persist = true) {
        this.collapsed = collapsed;
        this.classList.toggle('is-collapsed', collapsed);
        this.handle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        this.handle.setAttribute('aria-label', collapsed ? this.handle.dataset.labelShow : this.handle.dataset.labelHide);
        this.updateInert();

        if (!persist) return;
        try {
          window.sessionStorage.setItem(this.storageKey, collapsed ? 'collapsed' : 'expanded');
        } catch (error) {}
      }

      updateInert() {
        if (!this.content) return;
        this.content.inert = this.collapsed && this.mql.matches;
      }

      onTouchStart(event) {
        this.touchStartY = event.touches[0]?.clientY ?? null;
      }

      onTouchEnd(event) {
        if (this.touchStartY == null || !this.mql.matches) return;
        const deltaY = (event.changedTouches[0]?.clientY ?? this.touchStartY) - this.touchStartY;
        this.touchStartY = null;
        if (deltaY > 30 && !this.collapsed) this.setCollapsed(true);
        if (deltaY < -30 && this.collapsed) this.setCollapsed(false);
      }
    }

    customElements.define('promotion-banner-dock', PromotionBannerDock);
  }

  } catch(e) { console.error(e); }
})();
})();
